const parseAminoAcidChange = (value = "") => {
  const match = value.match(/^([A-Za-z]+)(\d+)([A-Za-z]+)$/);
  if (!match) return null;

  const [, refAa, aaPosition, altAa] = match;
  return { refAa, aaPosition, altAa };
};

const snpExamples = [
  {
    key: "NC_000021.8:g.7232464_7232465insC",
    id: "NC_000021.8:g.7232464_7232465insC",
    label: "NC_000021.8:g.7232464_7232465insC",
    type: "genomic",
    queryType: "Genomic Allele Query (HGVS)",
    queryParams: {
      genomicAlleleShortForm: "NC_000021.8:g.7232464_7232465insC",
    },
  },
];

const genomicVariantExamples = [
  {
    key: "BRCA1:Pro1856Ser",
    id: "BRCA1:Pro1856Ser",
    label: "BRCA1:p.Pro1856Ser",
    type: "genomic",
    queryType: "Gene ID",
    queryParams: {
      geneId: "BRCA1",
      ...parseAminoAcidChange("Pro1856Ser"),
    },
  },
  {
    key: "NC_000008.10:g.467881_467885delinsA",
    id: "NC_000008.10:g.467881_467885delinsA",
    label: "NC_000008.10:g.467881_467885delinsA",
    type: "genomic",
    queryType: "Genomic Allele Query (HGVS)",
    queryParams: {
      genomicHGVSshortForm: "NC_000008.10:g.467881_467885delinsA",
    },
  },
  {
    key: "NC_000017.10:g.43045703_43045705",
    id: "NC_000017.10:g.43045703_43045705",
    label: "NC_000017.10:g.43045703_43045705",
    type: "genomic",
    queryType: "Bracket Query",
    queryParams: {
      assemblyId: "GRCh37",
      referenceName: "17",
      start: [43045703, 43045704],
      end: [43045704, 43045705],
    },
  },
  {
    key: "GRCh37:2:343675-345681",
    id: "GRCh37:2:343675-345681",
    label: "GRCh37:2:343675-345681",
    type: "genomic",
    queryType: "Range Query",
    queryParams: {
      assemblyId: "GRCh37",
      referenceName: "2",
      start: [343675],
      end: [345681],
    },
  },
];

const proteinExamples = [
  {
    key: "DMD Met3685Val",
    id: "DMD Met3685Val",
    label: "DMD Met3685Val",
    type: "genomic",
    queryType: "Gene ID",
    queryParams: {
      geneId: "DMD",
      ...parseAminoAcidChange("Met3685Val"),
    },
  },
  {
    key: "DLGAP2",
    id: "DLGAP2",
    label: "DLGAP2",
    type: "genomic",
    queryType: "Gene ID",
    queryParams: { geneId: "DLGAP2" },
  },
  {
    key: "OTC",
    id: "OTC",
    label: "OTC",
    type: "genomic",
    queryType: "Gene ID",
    queryParams: { geneId: "OTC" },
  },
  {
    key: "DMD",
    id: "DMD",
    label: "DMD",
    type: "genomic",
    queryType: "Gene ID",
    queryParams: { geneId: "DMD" },
  },
];

const molecularEffectLabels = [
  {
    key: "ENSGLOSSARY:0000174",
    id: "ENSGLOSSARY:0000174",
    label: "intergenic_region",
    type: "ontology",
    scope: "genomicVariation",
  },
  {
    key: "ENSGLOSSARY:0000150",
    id: "ENSGLOSSARY:0000150",
    label: "missense_variant",
    type: "ontology",
    scope: "genomicVariation",
  },
];

export const filterLabels = {
  "SNP Examples": snpExamples,
  "Genomic Variant Examples": genomicVariantExamples,
  "Protein Examples": proteinExamples,
  "Molecular Effect": molecularEffectLabels,
};
